import { styled } from 'baseui';
import { LabelXSmall } from 'baseui/typography';
export const statefulTooltipSidePanelOverrides = {
  Inner: {
    style: ({
      $theme
    }) => ({
      backgroundColor: $theme.colors.backgroundTertiary
    })
  },
  Body: {
    style: ({
      $theme
    }) => ({
      backgroundColor: $theme.colors.backgroundTertiary
    })
  },
  Arrow: {
    style: ({
      $theme
    }) => ({
      backgroundColor: $theme.colors.backgroundTertiary
    })
  }
};
export const TooltipContentLabel = styled(LabelXSmall, ({
  $theme
}) => ({
  margin: 0,
  color: $theme.colors.contentPrimary
}));